// Sprint 11 A2+A6: Industry Intelligence section (from vertical benchmarks)

interface IndustryComparison {
  metric: string;
  yourValue: number;
  industryAvg: number | null;
  top10Percent: number | null;
  unit: string;
}

export function BriefingIndustryIntel({ comparisons }: { comparisons: IndustryComparison[] }) {
  if (comparisons.length === 0) return null;

  return (
    <div>
      <h2 className="text-sm font-bold text-[var(--color-muted-foreground)] uppercase tracking-wide mb-3">Industry Intel</h2>
      <div className="space-y-2">
        {comparisons.map((c) => {
          const isAbove = c.industryAvg != null && c.yourValue >= c.industryAvg;
          return (
            <div key={c.metric} className="text-xs border-b border-[var(--color-border)] pb-1.5">
              <div className="flex justify-between">
                <span className="text-[var(--color-muted-foreground)] capitalize">{c.metric.replace(/([A-Z])/g, " $1")}</span>
                <span className={isAbove ? "text-[var(--color-success)] font-medium" : "text-[var(--color-warning)] font-medium"}>
                  {formatValue(c.yourValue, c.unit)}
                </span>
              </div>
              {c.industryAvg != null && (
                <div className="text-[10px] text-[var(--color-muted-foreground)] mt-0.5">
                  Industry: {formatValue(c.industryAvg, c.unit)}
                  {c.top10Percent != null && ` | Top 10%: ${formatValue(c.top10Percent, c.unit)}`}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function formatValue(value: number, unit: string): string {
  if (unit === "%") return Math.round(value * 100) + "%";
  if (unit === "days") return value + "d";
  return new Intl.NumberFormat("en", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value / 100);
}
